import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipProgressBar = ({
  upgradeKey,
  currentUsage,
  usageLimit
}) => {
  const usageRemaining = Math.max(0, usageLimit - currentUsage);
  const usageRemainingI18nKey = isValidI18nKey(`usageLimitCounter.${upgradeKey}.tooltipUsageRemaining`) ? `usageLimitCounter.${upgradeKey}.tooltipUsageRemaining` : 'usageLimitCounter.defaultCopy.tooltipUsageRemaining';
  const usageCounterI18nKey = isValidI18nKey(`usageLimitCounter.${upgradeKey}.tooltipUsageCounter`) ? `usageLimitCounter.${upgradeKey}.tooltipUsageCounter` : 'usageLimitCounter.defaultCopy.tooltipUsageCounter';
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Progress, {
      use: "warning",
      value: currentUsage / usageLimit * 100,
      descriptiveLabel: /*#__PURE__*/_jsx(Text, {
        as: "small",
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: usageRemainingI18nKey,
          options: {
            usageRemaining
          }
        })
      }),
      valueLabel: /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: usageCounterI18nKey,
          options: {
            currentUsage,
            usageLimit
          }
        })
      })
    })
  });
};
export default TooltipProgressBar;